// extracted by mini-css-extract-plugin
export var productImage = "_oo-1";
export var viewLink = "_oo-2";
export var wishlistItem = "_oo-0";